import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';

import { LandingPage } from '../../components/LandingPage';
import { selectConsultantPhone } from '../../selectors/consultantContacts';
import { selectHhIsHidden } from '../../selectors/hh/selectHhIsHidden';
import { trackKpnCallClick } from '../../utils/analytics';
import { ContactsModalWindowContainer } from '../ContactsModalWindow';
import { RequestFormModalWindowContainer } from '../RequestFormModalWindow';

export const LandingPageContainer: React.FC = () => {
  const [requestModalOpen, setRequestModalOpen] = React.useState(false);
  const [contactsModalOpen, setContactsModalOpen] = React.useState(false);
  const isCallConsultantButtonHidden = useSelector(selectHhIsHidden);

  const phone = useSelector(selectConsultantPhone);
  const deviceType = useDeviceType();

  const handleCallButtonClick = () => {
    if (deviceType === 'desktop') {
      setContactsModalOpen(true);
    } else {
      window.location.assign(`tel:${phone}`);
    }

    trackKpnCallClick();
  };

  const handleRequestButtonClick = () => {
    setRequestModalOpen(true);
  };

  const closeRequestModal = React.useCallback(() => {
    setRequestModalOpen(false);
  }, []);

  const closeContactsModal = React.useCallback(() => {
    setContactsModalOpen(false);
  }, []);

  return (
    <>
      <LandingPage
        onCallButtonClick={handleCallButtonClick}
        onRequestButtonClick={handleRequestButtonClick}
        isCallConsultantButtonHidden={isCallConsultantButtonHidden}
      />
      <RequestFormModalWindowContainer open={requestModalOpen} onClose={closeRequestModal} />
      <ContactsModalWindowContainer open={contactsModalOpen} onClose={closeContactsModal} />
    </>
  );
};
